import { RyeconDuotoneStar } from '@dbt-labs/sourdough';

export const RyeconFavoriteFilled = () => {
  return (
    <RyeconDuotoneStar
      accentClassName="text-fgVizAmber"
      className="text-fgVizAmber hover:text-fgVizAmberHover"
      height={16}
      width={16}
      testId="ryecon-duotone-star-filled"
    />
  );
};

export const RyeconFavoriteOutline = () => {
  return (
    <RyeconDuotoneStar
      accentClassName="text-fgAlt hover:text-fgAltHover"
      className="text-fgInverse hover:text-fgAltHover"
      height={16}
      width={16}
      testId="ryecon-duotone-star-outline"
    />
  );
};
